(function($) {
  //caches a jQuery object containing the header element

    var header = $(".header");

    // Header follow
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
  
      if (scroll >= 500) {
        header.addClass("active-scroll");
      } else {
        header.removeClass("active-scroll");
      }
    });


  function menuDesktop() {


    $(".header-mobile__trigger").click(function() {
      $(".hamburger").toggleClass("is-active");

      $(".header-aside").toggleClass("header-aside--open");

      // $(".backplate").toggleClass("backplate--open");

      if ($(".hamburger").hasClass("is-active")) {
        $(".negativo").fadeTo("slow", 0, () => {
          $(".positivo").fadeTo("slow", 1);
        });
      } else {
        $(".positivo")
          .delay(window.innerWidth < 768 ? 0 : 600)
          .fadeTo(500, 0, () => {
            $(".negativo").fadeTo(500, 1);
          });
      }

      if (window.innerWidth < 768) {
        $(".header").toggleClass("text-white");
      }

      //   if (!$(this).hasClass("is-active")) {
      //     $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
      //     $(".btn-nav").removeClass("btn-nav--active");
      //     $(".sub-menu").removeClass("sub-menu--active");
      //   }
    });

    $(".backplate").click(function() {
      $(".header-aside").toggleClass("header-aside--open");
    });



    $('.header-aside li a[href*=\\#]').not('[href="#"]').not('[href="#0"]').not('[href="#pll_switcher"]').on('click', function (event) {
      if(this.pathname === window.location.pathname){
        $(".hamburger").removeClass("is-active");
        $(".header-aside").toggleClass("header-aside--open");
        // $(".header-aside").removeClass("header-aside--open");
        // $(".backplate").removeClass("backplate--open");
      }
    });

    $('.header-aside li.menu-item-has-children > a').on('click', function (e) {
      e.preventDefault();
      $(this).next('.sub-menu').slideToggle();
      $(this).closest('li').toggleClass('active');
    });



  }

  $(document).ready(function() {
    menuDesktop();
  });
})(jQuery);


